import { TriangleLeft } from "@styled-icons/entypo";
import { Typography } from "components/parts/Typography/Typography";
import { fontSize } from "constants/fontSize";
import { newColors } from "constants/newColors";
import { CheckCircle } from "@styled-icons/boxicons-regular/CheckCircle";
import styled, { css } from "styled-components";

export const StyledInterviewDetailCard = styled.div`
  display: flex;
  flex-direction: column;
  background: ${newColors.white};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  height: 100%;
  overflow-y: scroll;
  padding: 1.5rem 2rem;
`;

export const StyledInterviewHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: 1rem;
  width: 100%;
  padding-bottom: 0.5rem;
  border-bottom: solid 1px ${newColors.border};
  margin-bottom: 1.5rem;
`;

export const StyledInterviewHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  column-gap: 1rem;
  margin-bottom: 0.5rem;
`;

export const StyledInterviewHeaderTitleWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 1rem;
`;

export const StyledTitleAndOpenAndEditButtonDiv = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  column-gap: 1rem;
  align-items: center;
`;

export const StyledTitleAndOpenButtonDiv = styled.div`
  display: flex;
  column-gap: 1rem;
  align-items: center;
  width: fit-content;
`;

export const StyledInterviewDetailContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 2rem;
  width: 100%;
  overflow-y: scroll;
`;

export const StyledInterviewDetailContentRow1 = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
  flex-grow: 1;
  min-width: 20em;
  width: 35%;
  margin-right: 1rem;
`;

export const StyledMonitor = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledMonitorContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 0 0 1rem;
`;

export const StyledMonitorWithInfoAdjuster = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 1rem;
`;

export const StyledMonitorWithInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledMonitorWithIsLogin = styled.div`
  display: flex;
  align-items: center;

  span:first-child {
    margin-right: 1rem;
  }

  span:last-child {
    margin-left: 1rem;
  }
`;

export const StyledCheckCircle = styled(CheckCircle)`
  color: ${newColors.green};
  width: ${fontSize.large};
  height: ${fontSize.large};
`;

export type StyledTransitionAdjusterProps = {
  selected: boolean;
};

export const StyledTransitionAdjuster = styled.div<StyledTransitionAdjusterProps>`
  display: flex;
  width: min-content;
  height: min-content;
  transition: transform 0.2s ease;
  cursor: pointer;

  ${({ selected }) =>
    selected &&
    css`
      transform: rotate(-90deg);
      transform-origin: center center;
    `}
`;

export const StyledTriangleLeft = styled(TriangleLeft)`
  display: flex;
  width: ${fontSize.xlarge};
  height: ${fontSize.xlarge};
  color: ${newColors.text};
`;

export const StyledMonitorInfoArea = styled.div`
  display: flex;
  row-gap: 1rem;
  flex-direction: column;
  margin: 1rem 0 0 1rem;
`;

export const StyledMonitorAttributeContent = styled.div`
  display: flex;
  flex-grow: 1;
  column-gap: 4em;
  width: 100%;
  padding-bottom: 0.5rem;
  border-bottom: solid 1px ${newColors.border};
`;

export const StyledAttributeNameTypography = styled(Typography)`
  display: flex;
  width: 10em;
`;

export const StyledAttributeValueTypography = styled(Typography)`
  display: flex;
  width: 12em;
  flex-grow: 1;
`;

export const StyledInterviewFlow = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-right: 1rem;
  width: 45%;
`;

export const StyledInterviewFlowContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0 0 1rem;
`;

export const StyledNoDataTypography = styled(Typography)`
  padding-top: 1rem;
`;

export const StyledMemo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledMemoContent = styled.div`
  display: flex;
  margin: 1rem 0 0 1rem;
`;
